import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Apis } from "../lib/Apis";
import Loader from "./loader";
import { clearStoredUser, setStoredUser } from "./permissionAccess";

const ProtectedRoute = ({ isLoggedIn, onUserLoaded, children }) => {
  const [isLoadingUser, setIsLoadingUser] = useState(isLoggedIn);
  const [hasValidSession, setHasValidSession] = useState(isLoggedIn);

  useEffect(() => {
    const fetchCurrentUser = async () => {
      if (!isLoggedIn) return;

      try {
        const response = await Apis.getUser();
        const user = response.data.getUser || response.data.user || response.data.data;
        setStoredUser(user);
        onUserLoaded?.(user);
        setHasValidSession(true);
      } catch {
        localStorage.removeItem("token");
        clearStoredUser();
        setHasValidSession(false);
      } finally {
        setIsLoadingUser(false);
      }
    };

    fetchCurrentUser();
  }, [isLoggedIn, onUserLoaded]);

  if (!isLoggedIn || !hasValidSession) return <Navigate to="/login" replace />;
  if (isLoadingUser) return <Loader message="Loading dashboard..." />;

  return children;
};

export default ProtectedRoute;
